import React, { createContext, useContext, useEffect, useState } from 'react'
import { categoriesApi } from '../restaurant.api'

const CategoriesContext = createContext({
  loading: true,
  categories: [],
  search: '',
  setSearch: () => {},
  refresh: () => {},
})

export const useCategories = () => useContext(CategoriesContext)

export const CategoriesProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [categories, setCategories] = useState([])
  const [search, setSearch] = useState('')

  const load = async () => {
    setLoading(true)
    const { response } = await categoriesApi.list()
    if (response) setCategories(response.data || [])
    setLoading(false)
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filtered = categories.filter((category) =>
    (category.name || '').toLowerCase().includes(search.toLowerCase())
  )

  return (
    <CategoriesContext.Provider
      value={{
        loading,
        categories: filtered,
        search,
        setSearch,
        refresh: load,
      }}
    >
      {children}
    </CategoriesContext.Provider>
  )
}
